/// <amd-module name="VSS/Redux/Modules/Navigation/NavigationSelectors" />
import { INavigationAwareState } from "VSS/Redux/Modules/Navigation/NavigationContracts";

/** Is the page navigating away? */
export function isNavigating(state: INavigationAwareState): boolean {
    return state.navigationState.isNavigating;
}
